module.exports = __webpack_public_path__ + "static/media/holiday.fc5c9ba4.svg";